var map = {
	"./letters/a.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/a.ogg",
	"./letters/aakar.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/aakar.ogg",
	"./letters/aakar_ekar.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/aakar_ekar.ogg",
	"./letters/ekar.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/ekar.ogg",
	"./letters/ga.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/ga.ogg",
	"./letters/ha.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/ha.ogg",
	"./letters/ka.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/ka.ogg",
	"./letters/kha.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/kha.ogg",
	"./letters/ma.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/ma.ogg",
	"./letters/ra.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/ra.ogg",
	"./letters/sa.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/sa.ogg",
	"./letters/taa.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/taa.ogg",
	"./letters/yo.ogg": "./src/Containers/Play/Decoding/content/audios/level1/letters/yo.ogg",
	"./sentences/aaha_timi_le.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sentences/aaha_timi_le.ogg",
	"./sentences/bujyeko_rahe_xau.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sentences/bujyeko_rahe_xau.ogg",
	"./sentences/ekdam_ramro.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sentences/ekdam_ramro.ogg",
	"./sentences/milyo.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sentences/milyo.ogg",
	"./sentences/timile_ta_bujye_xau.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sentences/timile_ta_bujye_xau.ogg",
	"./sentences/yo_pani_milyo.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sentences/yo_pani_milyo.ogg",
	"./sound/aama/1.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/aama/1.ogg",
	"./sound/aama/2.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/aama/2.ogg",
	"./sound/aama/3.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/aama/3.ogg",
	"./sound/aama/4.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/aama/4.ogg",
	"./sound/haat/1.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/haat/1.ogg",
	"./sound/haat/2.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/haat/2.ogg",
	"./sound/haat/3.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/haat/3.ogg",
	"./sound/kera/1.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kera/1.ogg",
	"./sound/kera/2.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kera/2.ogg",
	"./sound/kera/3.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kera/3.ogg",
	"./sound/kera/4.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kera/4.ogg",
	"./sound/kharayo/1.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kharayo/1.ogg",
	"./sound/kharayo/2.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kharayo/2.ogg",
	"./sound/kharayo/3.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kharayo/3.ogg",
	"./sound/kharayo/4.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kharayo/4.ogg",
	"./sound/kharayo/5.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/kharayo/5.ogg",
	"./sound/saag/1.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/saag/1.ogg",
	"./sound/saag/2.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/saag/2.ogg",
	"./sound/saag/3.ogg": "./src/Containers/Play/Decoding/content/audios/level1/sound/saag/3.ogg",
	"./words/aama.ogg": "./src/Containers/Play/Decoding/content/audios/level1/words/aama.ogg",
	"./words/haat.ogg": "./src/Containers/Play/Decoding/content/audios/level1/words/haat.ogg",
	"./words/kera.ogg": "./src/Containers/Play/Decoding/content/audios/level1/words/kera.ogg",
	"./words/kharayo.ogg": "./src/Containers/Play/Decoding/content/audios/level1/words/kharayo.ogg",
	"./words/saag.ogg": "./src/Containers/Play/Decoding/content/audios/level1/words/saag.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/Decoding/content/audios/level1 sync recursive ^\\.\\/.*$";